import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import '@/scss/design.scss';

// プラグイン登録（一括）
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/*------------------------------------------------
初期実行 (DOM生成直後)
--------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
  initHamburger();
  initCurrentNav();
});

/*------------------------------------------------
ハンバーガーメニュー
--------------------------------------------------*/
function initHamburger() {
  const button = document.querySelector('.hd_menu_btn');
  const nav_box = document.querySelector('.hd_nav_box');
  const links = document.querySelectorAll('.hd_nav_link');

  if (!button || !nav_box) return;

  button.addEventListener('click', () => {
    nav_box.classList.toggle('is_open');
    button.classList.toggle('is_close');
  });

  links.forEach((link) => {
    link.addEventListener('click', () => {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });
}

/*------------------------------------------------
カードの重なりアニメーション (最優先計算)
--------------------------------------------------*/
function initCardAnimation() {
  const section = document.querySelector('.cardSection');
  const cards = gsap.utils.toArray('.cardItem');
  const headerEl = document.querySelector('.header');

  if (!section || cards.length === 0) return;

  const mm = gsap.matchMedia();

  mm.add("(min-width: 1025px)", () => {
    gsap.set(cards, {
      position: (i) => i === 0 ? "relative" : "absolute",
      top: 0,
      left: 0,
      width: "100%",
      zIndex: (i) => i,
      yPercent: (i) => i === 0 ? 0 : 100
    });

    const headerHeight = headerEl ? headerEl.offsetHeight : 0;
    const tl = gsap.timeline();

    tl.to({}, { duration: 1 }); // 最初のタメ

    cards.forEach((card, index) => {
      if (index > 0) {
        tl.to(card, {
          yPercent: 0,
          duration: 1,
          ease: "none"
        })
        .to({}, { duration: 1 }); // 重なった後の停止時間
      }
    });

    ScrollTrigger.create({
      id: "cardAnim",
      trigger: section,
      start: `top top+=${headerHeight}`,
      end: () => `+=${window.innerHeight * 4}`,
      pin: true,
      scrub: true,
      animation: tl,
      invalidateOnRefresh: true,
      refreshPriority: 10, // ★最優先で計算させる
    });

    return () => {
      gsap.set([section, ...cards], { clearProps: "all" });
    };
  });

  if (!document.body.classList.contains("home")) {
    mm.revert();
  }
}

/*------------------------------------------------
要素・タイトルアニメーション (固定を考慮)
--------------------------------------------------*/
function initOtherAnimations() {
  const cardSection = document.querySelector('.cardSection');

  // ふわっと出る要素 (.scrollAnim)
  const items = document.querySelectorAll('.scrollAnim');
  items.forEach((target) => {
    ScrollTrigger.create({
      trigger: target,
      start: "top 90%",
      pinnedContainer: cardSection, // ★カード固定中のズレを補正
      onEnter: () => target.classList.add('active'),
    });
  });

  // タイトルアニメーション
  const titles = document.querySelectorAll('.cmn_title.anime');
  titles.forEach(title => {
    const titleJa = title.parentElement.querySelector('.cmn_subtitle.anime');
    if (!titleJa) return;

    splitTextToSpans(title);
    splitTextToSpans(titleJa);

    const titleSpans = title.querySelectorAll('span');
    const titleJaSpans = titleJa.querySelectorAll('span');
    const maxLength = Math.max(titleSpans.length, titleJaSpans.length);

    ScrollTrigger.create({
      trigger: title,
      start: 'top 70%',
      pinnedContainer: cardSection, // ★カード固定中のズレを補正
      onEnter: () => {
        for (let i = 0; i < maxLength; i++) {
          const targets = [];
          if (titleSpans[i]) targets.push(titleSpans[i]);
          if (titleJaSpans[i]) targets.push(titleJaSpans[i]);

          gsap.to(targets, {
            opacity: 1,
            x: 0,
            duration: 1,
            ease: 'power2.out',
            delay: i * 0.05
          });
        }
      }
    });
  });
}

function splitTextToSpans(el) {
  const text = el.textContent;
  el.innerHTML = text
    .split('')
    .map(char => `<span style="display:inline-block; opacity:0; transform:translateX(30px)">${char}</span>`)
    .join('');
}

/*------------------------------------------------
ナビゲーション・カレント・スムーススクロール
--------------------------------------------------*/
function initCurrentNav() {
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.hd_nav_link');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const id = entry.target.getAttribute('id');
      const activeLink = document.querySelector(`.hd_nav_link[href="#${id}"]`);
      if (entry.isIntersecting) {
        navLinks.forEach(link => link.classList.remove('is-active'));
        if (activeLink) activeLink.classList.add('is-active');
      } else if (activeLink) {
        activeLink.classList.remove('is-active');
      }
    });
  }, { root: null, rootMargin: "-50% 0px", threshold: 0 });

  sections.forEach(section => observer.observe(section));

  // ページ内リンク
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      const id = link.getAttribute("href");
      const target = document.querySelector(id);
      if (!target || id === "#") return;
      e.preventDefault();
      const offsetValue = window.innerWidth >= 1024 ? 99 : 50;
      gsap.to(window, {
        duration: 0.5,
        scrollTo: { y: target, offsetY: offsetValue, autoKill: false }
      });
    });
  });
}

/*------------------------------------------------
スライダー・雲・その他
--------------------------------------------------*/
function initLoopSliderSmooth() {
  const sliderWraps = document.querySelectorAll('.loopSlider .loopslider_wrap');
  sliderWraps.forEach(sliderWrap => {
    const ul = sliderWrap.querySelector('ul');
    if (!ul || sliderWrap.querySelectorAll('ul').length > 1) return;
    const clone1 = ul.cloneNode(true);
    const clone2 = ul.cloneNode(true);
    sliderWrap.insertBefore(clone2, ul);
    sliderWrap.insertBefore(clone1, ul);
    const uls = sliderWrap.querySelectorAll('ul');
    let totalWidth = 0;
    uls.forEach(u => totalWidth += u.offsetWidth);
    sliderWrap.style.width = totalWidth + 'px';
    sliderWrap.animate([
      { transform: `translateX(-${ul.offsetWidth}px)` },
      { transform: 'translateX(0)' }
    ], { duration: 200000, iterations: Infinity, easing: 'linear' });
  });
}

function initCloudObserver() {
  const cloudTargets = document.querySelectorAll('.item_left, .item_right');
  const cloudObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-show');
        cloudObserver.unobserve(entry.target);
      }
    });
  }, { root: null, rootMargin: '0px 0px -40% 0px', threshold: 0 });
  cloudTargets.forEach(target => cloudObserver.observe(target));
}

/*------------------------------------------------
実行
--------------------------------------------------*/
window.addEventListener('load', () => {
  initCardAnimation();
  initOtherAnimations();
  initLoopSliderSmooth();
  initCloudObserver();

  // ページ外リンク用ハッシュスクロール
  if (location.hash) {
    const header = document.querySelector('.nav');
    const headerHeight = header ? header.offsetHeight : 0;
    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: { y: location.hash, offsetY: headerHeight }
      });
    }, 100);
  }

  // 最後にScrollTriggerを再計算
  ScrollTrigger.refresh();
});

// リサイズ対応
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initCardAnimation();
    ScrollTrigger.refresh();
  }, 200);
});